import { render, staticRenderFns } from "./new_add.vue?vue&type=template&id=0312173a&scoped=true&"
import script from "./new_add.vue?vue&type=script&lang=js&"
export * from "./new_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0312173a",
  null
  
)

export default component.exports